/** A material bag's draw-specific forms, kept per bag so that a render that changes nothing hands R3F the same props. */
import { perObject } from '../../utils/perObject';
/**
 * A store of forms by bag and draw key, which hands back the form it built first for each pair.
 *
 * @canonical A cache of a material bag's draw forms
 */
export function bagForms() {
    const formsOf = perObject(() => new Map());
    return (bag, key, build) => {
        const forms = formsOf(bag);
        const known = forms.get(key);
        if (known)
            return known;
        const form = build();
        forms.set(key, form);
        return form;
    };
}
//# sourceMappingURL=bagForms.js.map